import { IPayerBase } from "../../types/Payer";
import authAxios, { authHeader } from "../data";

const fetchAll = async (req: any) => {
  const response = await authAxios.get("/api/ContractPayers", {
    params: req,
    headers: authHeader(),
  });

  return response.data;
};

const fetch = async (id: string) => {
  const response = await authAxios.get("/api/ContractPayers/" + id, {
    headers: authHeader(),
  });

  return response.data;
};

const remove = async (id: string) => {
  const response = await authAxios.delete("/api/ContractPayers/" + id, {
    headers: authHeader(),
  });

  return response.data;
};

const create = async (req: IPayerBase) => {
  const response = await authAxios.post("/api/ContractPayers", req, {
    headers: authHeader(),
  });

  return response.data;
};

const edit = async (id: string, req: IPayerBase) => {
  const response = await authAxios.put("/api/ContractPayers/" + id, req, {
    headers: authHeader(),
  });

  return response.data;
};

const PayersService = {
  fetchAll,
  remove,
  create,
  fetch,
  edit,
};

export default PayersService;
